import {createSlice} from "@reduxjs/toolkit";
import { initialFilter } from "../../pages/movements/MovementsUIHelpers";

const initialMovementsState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  queryParams: initialFilter,
  stores: []
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const movementsSlice = createSlice({
  name: "movements",
  initialState: initialMovementsState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    storesFetched: (state, action) => {
      state.listLoading = false;
      state.stores = action.payload.stores.map(x => {
        return {value: x.id, label: x.name}
      });
      state.error = null;
    },
    // findMovements
    movementsFetched: (state, action) => {
      const { totalCount, entities, pageSize, pageNumber } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      state.queryParams.pageSize = pageSize;
      state.queryParams.pageNumber = pageNumber;
      state.movementForEdit = undefined;
    },
    // Pagination
    updateQueryParams: (state, action) => {
      state.queryParams = action.payload.queryParams;
    },
    updateQueryParamsAndReset: (state, action) => {
      state.queryParams = action.payload.queryParams;
      state.entities = [];
      state.totalCount = 0;
    },
  }
});
